<template>
  <div>
    <div class="sayfahead m-0 sayfahead-xs">
      <h1><small>Mesken İnternet</small></h1>
      <el-button-group class="YeniBtn">

        <el-button type="danger" size="small" v-if="!Bilgi.Pasif" @click="Hizmet(true)">Hizmeti Duraklat</el-button>
        <el-button type="success" size="small" v-if="Bilgi.Pasif" @click="Hizmet(false)">Hizmeti Aktif Et</el-button>
        <el-button type="primary" size="small" @click="SayfaYukle">Yenile</el-button>
      </el-button-group>
    </div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <table v-if="Bilgi" class="table table-xs table-bordered">
      <tbody>
      <tr>
        <td width="100">
          <small>Kullanıcı Adı</small>
          {{Bilgi.iKadi}}
        </td>
        <td width="100">
          <small>Kullanıcı Sayısı</small>
          {{Bilgi.iUse}}
        </td>
        <td width="100">
          <small>Şifre</small>
          {{Bilgi.iSifre}}
        </td>
        <td width="100">
          <small>Tarife</small>
          {{Bilgi.Tarife}}
        </td>
        <td width="100" class="bg-danger text-white" v-if="Bilgi.Pasif">
          <small>Hizmet Duraklama Tarihi</small>
          {{Bilgi.Pasif}}
        </td>
      </tr>
      </tbody>
    </table>
    <el-row style="margin: 10px">
      <el-col :span="6">
        <mWidget
          :data="{isim: '30 Gün Upload', sayi: this.Rapor.AylikUpload, icon: 'el-icon-upload2', renk: 'ins2 m-widget-mini'}"></mWidget>
      </el-col>
      <el-col :span="6">
        <mWidget
          :data="{isim: '30 Gün Download', sayi: this.Rapor.AylikDownload, icon: 'el-icon-download', renk: 'ins4 m-widget-mini'}"></mWidget>
      </el-col>
      <el-col :span="6">
        <mWidget
          :data="{isim: 'Aktif Upload', sayi: this.Rapor.AnlikUpload, icon: 'el-icon-arrow-up', renk: 'ins8 m-widget-mini'}"></mWidget>
      </el-col>
      <el-col :span="6">
        <mWidget
          :data="{isim: 'Aktif Download', sayi: this.Rapor.AnlikDownload, icon: 'el-icon-arrow-down', renk: 'ins9 m-widget-mini'}"></mWidget>
      </el-col>
    </el-row>
    <el-divider content-position="left">Son 10 Bağlantı</el-divider>
    <table class="table table-xs">
      <thead>
      <tr>
        <th>B.Türü</th>
        <th>Başlama Zamanı</th>
        <th>Bitiş Zamanı</th>
        <th>Trafik</th>
        <th>İP</th>
        <th>Mac</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="b in Baglantilar">
        <td>{{b.Tur}}</td>
        <td>{{b.Baslangic}}</td>
        <td>{{b.Bitis}}</td>
        <td>{{b.Trafik}}</td>
        <td>{{b.ip}}</td>
        <td>{{b.Mac}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import mWidget from "../Genel/mWidget";
  import Yukleniyor from "../../Doc/Yukleniyor";

  export default {
    components: {Yukleniyor, mWidget},
    props: ['Mesken_id'],
    data() {
      return {
        lo: false,
        Bilgi: null,
        Baglantilar: null,
        Rapor: {
          AylikUpload: 0,
          AylikDownload: 0,
          AnlikUpload: 0,
          AnlikDownload: 0,
        }
      }
    },
    methods: {
      Hizmet(durum) {
        this.$store.dispatch("Post", {...this.Bilgi, path: '_radius/expiration/' + durum})
          .then(response => {
            if (response.Durum === 'OK') {
              this.lo = false;
              this.$message.success(response.Mesaj);
              this.SayfaYukle();
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });

      },
      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {path: '_radius/kullanici/d/' + this.Mesken_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Bilgi = response.Bilgi;
              this.Baglantilar = response.Baglantilar;
              this.Rapor = response.Rapor;
              this.lo = false;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      }
    },
    created() {
      this.SayfaYukle();
    }
  }
</script>

<style scoped>
  table small {
    display: block;
  }

  .YeniBtn {
    top: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pack/Internet/MeskenInternet.vue